"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class CRMApi {
    constructor(api) {
        this.api = api;
    }
    /**
     * [BE] CA-1665
     * user 加入了哪些 group
     */
    getJoinedGroups(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/group';
            const resposne = yield this.api.axiosGo.get(endpoint, { params: options });
            return resposne.data;
        });
    }
    /**
     * [BE] CA-1665
     * group 的資料及 user 是否有加入、積分
     */
    getGroupById(groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/group/${groupId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * [BE] MP-509
     * group 的資料及 user 是否有加入、積分
     */
    getGroupByMerchantId(merchantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/merchant/${merchantId}/group`;
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * @deprecated 沒有使用到
     * [BE] CA-1665
     * group 有哪些 merchants
     */
    getGroupMerchants(groupId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/group/${groupId}/merchant`;
            const resposne = yield this.api.axiosGo.get(endpoint, { params: options });
            return resposne.data;
        });
    }
    /**
     * [BE] MR-2348
     * user 的積分記錄
     */
    getGroupLedgers(groupId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/point';
            const resposne = yield this.api.axiosGo.get(endpoint, { params: Object.assign(Object.assign({}, options), { groupId }) });
            return resposne.data;
        });
    }
    /**
     * [BE] MP-504
     * group 的積分獎勵
     */
    getGroupRewards(groupId, merchantId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/group/${groupId}/reward`;
            const params = Object.assign(Object.assign({}, options), { merchantId }); // 僅需顯示 enabled 的 rewards
            const resposne = yield this.api.axiosGo.get(endpoint, { params });
            return resposne.data;
        });
    }
    /**
     * CA-1666
     * 加入 CRM 會員
     */
    registerCRM(groupId, merchantId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/group/${groupId}/user`;
            const data = { merchantId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
}
exports.default = CRMApi;
//# sourceMappingURL=CRM.js.map